import {ChangeDetectionStrategy, Component, ElementRef, forwardRef, Input, NgZone, OnChanges, OnDestroy, OnInit} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {Tools} from "linkurious-shared";

const UI_SWITCH_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SwitchComponent),
  multi: true
};

@Component({
  selector: 'switch',
  template: `<label class="switch">
  <input type="checkbox" [(ngModel)]="checked" [disabled]="disabled">
  <span class="switch__slider switch__slider--round"></span>
</label>
`,
  styles: [`.switch{position:relative;display:block;width:37px;height:23px}.switch input{display:none}.switch input:disabled+.switch__slider{opacity:.5}.switch input:checked+.switch__slider{background-color:#0081e3;border:1px solid #0081e3}.switch input:checked+.switch__slider:before{background-color:#fff;left:17px}.switch input:focus+.switch__slider{box-shadow:0 0 1px #0081e3}.switch .switch__slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#fff;border:1px solid #cbcbcb;transition:.4s}.switch .switch__slider:before{position:absolute;content:"";height:15px;width:15px;left:3px;bottom:3px;background-color:#878787;transition:.4s}.switch .switch__slider.switch__slider--round{border-radius:34px}.switch .switch__slider.switch__slider--round:before{border-radius:50%}`],
  providers: [UI_SWITCH_CONTROL_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchComponent implements ControlValueAccessor, OnInit, OnChanges, OnDestroy {

  @Input() on: any = true;
  @Input() off: any = false;
  @Input() check: boolean;
  @Input() disabled: boolean;

  private _checked: boolean;

  constructor(
    private _element: ElementRef,
    private _ngZone: NgZone
  ) {}

  ngOnInit() {
    this._ngZone.runOutsideAngular(() => {
      this._element.nativeElement.addEventListener('click', this.onClick.bind(this));
    });
  }

  ngOnChanges() {
    if ( Tools.isDefined(this.check) ) {
      this.checked = this.check;
    }
  }

  ngOnDestroy() {
    this._element.nativeElement.removeEventListener('click', this.onClick.bind(this));
  }

  private onClick(e: MouseEvent) {
    if ( Tools.isDefined(this.check) ) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  private propagateChange: any = () => {};

  public get checked() {
    return this._checked;
  }

  public set checked(v: boolean) {
    this._checked = v;
    this.propagateChange(v ? this.on : this.off);
  }

  writeValue(obj: any): void {
    this.checked = ( obj === this.on );
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {}

}
